"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editionMarkerV2Beet = exports.EditionMarkerV2 = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const Key_1 = require("../types/Key");
class EditionMarkerV2 {
    constructor(key, ledger) {
        this.key = key;
        this.ledger = ledger;
    }
    static fromArgs(args) {
        return new EditionMarkerV2(args.key, args.ledger);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return EditionMarkerV2.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) {
            throw new Error(`Unable to find EditionMarkerV2 account at ${address}`);
        }
        return EditionMarkerV2.fromAccountInfo(accountInfo, 0)[0];
    }
    static gpaBuilder(programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.editionMarkerV2Beet);
    }
    static deserialize(buf, offset = 0) {
        return exports.editionMarkerV2Beet.deserialize(buf, offset);
    }
    serialize() {
        return exports.editionMarkerV2Beet.serialize(this);
    }
    static byteSize(args) {
        const instance = EditionMarkerV2.fromArgs(args);
        return exports.editionMarkerV2Beet.toFixedFromValue(instance).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(EditionMarkerV2.byteSize(args), commitment);
    }
    pretty() {
        return {
            key: 'Key.' + Key_1.Key[this.key],
            ledger: this.ledger,
        };
    }
}
exports.EditionMarkerV2 = EditionMarkerV2;
exports.editionMarkerV2Beet = new beet.FixableBeetStruct([
    ['key', Key_1.keyBeet],
    ['ledger', beet.bytes],
], EditionMarkerV2.fromArgs, 'EditionMarkerV2');
//# sourceMappingURL=EditionMarkerV2.js.map